import { AbstractPmsApiService } from './abstract.service';

/**
 * @class InvoiceContentPmsApiService
 * @abstract
 * @extends {AbstractPmsApiService<>}
 */
export class InvoiceContentPmsApiService extends AbstractPmsApiService {

    /**
     * @param {$http} http
     * @param {ConfigPmsApiService} config
     * @param {EventsBrokerPmsApiService} eventsBroker
     * @param {DownloadFile} DownloadFile
     */
    constructor(http, config, eventsBroker, DownloadFile) {

        super(http, config, eventsBroker);

        this.DownloadFile = DownloadFile;

    }

    /**
     * @type {string[]}
     */
    static get $inject() {
        return super.$inject.concat([
            'DownloadFile'
        ]);
    }

    /**
     * @type {string}
     * @protected
     */
    get urlPattern() {

        return '/invoice-content/:propertyId/:token';
    }

    getContent(propertyId, token) {

        const url = this.url({
            propertyId: propertyId,
            token: token,
        });

        return this.http
            .get(url, {
                headers: this.authHeaders,
            })
            .then(this.getDataExtractor())
            .catch(this.getErrorHandler());
    }
}



// WEBPACK FOOTER //
// ./src/pms-api/services/invoice-content.service.js